import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import type { PageComponentProps } from '../../../../components';
import { visitorDrawerStateAtom } from '../../../../visitor/state';
import { usePreSessionPromptState } from '../../../waiting-room/pre-session-prompt/usePreSessionPromptState';
import { useMoodCheckinCustomResponseState, useMoodCheckinSelectionsState } from './useMoodCheckinSelectionsState';
import { useSyncMoodCheckinChoicesCallback } from './useSyncMoodCheckinChoicesCallback';

export function Actions({ isFirstPage, prevPage }: PageComponentProps<string[]>) {
  const t = useTranslate();
  const [selections] = useMoodCheckinSelectionsState();
  const [customResponse, setCustomResponse] = useMoodCheckinCustomResponseState();
  const onSyncChoices = useSyncMoodCheckinChoicesCallback();
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { clearPreSessionPrompt } = usePreSessionPromptState();

  const onSaveAndCloseDrawer = useCallback(() => {
    const emotionsToSync = customResponse.trim() ? [...selections, customResponse.trim()] : selections;

    if (!emotionsToSync.length) return;

    onSyncChoices(emotionsToSync, {
      onCompleted() {
        setCustomResponse('');
        setDrawerState(null);
        clearPreSessionPrompt();
      },
    });
  }, [onSyncChoices, selections, customResponse, setCustomResponse, setDrawerState, clearPreSessionPrompt]);

  return (
    <>
      {!isFirstPage && (
        <Button onClick={prevPage} use='secondary'>
          {t('telehealth-core:moodCheckin.previous')}
        </Button>
      )}
      <Button onClick={onSaveAndCloseDrawer}>{t('telehealth-core:moodCheckin.saveAndClose')}</Button>
    </>
  );
}
